export default __webpack_public_path__ + "static/media/warehouse-icon.48b49796.svg";